import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {title:'超级课堂'}
    },
    {
      path: '/nayang',
      name: 'nayang',
      component: () => import(/* webpackChunkName: "nayang" */ './views/nayang.vue'),
      meta: {title:'幼儿硬笔书法超值套餐'}
    },
    {
      path: '/act',
      name: 'act',
      component: () => import(/* webpackChunkName: "act" */ './views/act.vue'),
      meta: {title:'小升初专题活动'}
    },
    {
      path: '/success',
      name: 'success',
      component: () => import(/* webpackChunkName: "group" */ './views/success.vue'),
      meta: {title:'成功开通会员'}
    },
    {
      path: '/wuyiAct',
      name: 'wuyiAct',
      component: () => import(/* webpackChunkName: "wuyiAct" */ './views/wuyiAct.vue'),
      meta: {title:'五一充值活动'}
    },
    {
      path: '/tiktok',
      name: 'tiktok',
      component: () => import(/* webpackChunkName: "tiktok" */ './views/tiktok.vue'),
      meta: {title:'抖音视频活动'}
    },
    {
      path: '/tiktokDetail',
      name: 'tiktokDetail',
      component: () => import(/* webpackChunkName: "tiktok" */ './views/tiktokDetail.vue'),
      meta: {title:'活动详情'}
    },
    {
      path: '/sevenDay',
      name: 'sevenDay',
      component: () => import(/* webpackChunkName: "exDays" */ './views/sevenDay.vue'),
      meta: {title:'校园公益活动'}
    },
    {
      path: '/exDays',
      name: 'exDays',
      component: () => import(/* webpackChunkName: "exDays" */ './views/exDays.vue'),
      meta: {title:'校园公益活动'}
    },
    {
      path: '/daySuccess',
      name: 'daySuccess',
      component: () => import(/* webpackChunkName: "exDays" */ './views/daySuccess.vue'),
      meta: {title:'开通成功'}
    },
    {
      path: '/pay',
      name: 'pay',
      component: () => import(/* webpackChunkName: "exDays" */ './views/pay.vue'),
      meta: {title:'支付详情'}
    }
  ]
})
